// extracted by mini-css-extract-plugin
export default {"modalContainerBg":"desktop_modalContainerBg__6RowB"};